module.exports = __webpack_public_path__ + "img/order_form_image@3x.77ee5a57.png";